import { PortalApiError } from '@afterpaytouch/portal-api'
import { PaymentOptionsError } from '../../model'

export interface CLRiskDeclineError {
  isError: boolean
  error: PortalApiError | PaymentOptionsError | undefined
  reset: () => void
  context?: FacilityContext
}

export enum FacilityContext {
  PreAssessment = 'preAssessment',
  Assessment = 'assessment',
  FacilityCreation = 'facilityCreation',
  IncomeAssessment = 'incomeAssessment',
}
